export default __webpack_public_path__ + "static/media/style0.a55a6a56.svg";